// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> dietz-property-group-prestige -> highpoint-apartments
// Generated: 2026-10-26T16:35:56.386Z
// Counts: 1 design, 8 content, 3 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "adtaxi-tracking.profile": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_adtaxi_domain"
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[0].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[0].image_media.alt_text"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "adtaxi-tracking",
      "blockId": "adtaxi-tracking",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "realpage-calendar",
      "blockId": "realpage-calendar",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
